export const COMMIT_SELECTIONS = "Selections/SELECTIONS_COMMIT";
